import { useToast } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  useDiscardDraftMutation, useGetFormDraftQuery, useGetFormQuery, usePublishFormMutation, useUpdateFormMutation,
} from '../../Services/apiSlice';
import EditorSidebar from './EditorSidebar';
import { getForm } from '../FormSetup/formSlice';

const FormEditorSidebar = () => {
  const { formId } = useParams();
  const [updateForm, { isLoading: isLoadingUpdate }] = useUpdateFormMutation();
  const [publishForm, { isLoading: isLoadingPublish }] = usePublishFormMutation();
  const [discardDraft, { isLoading: isLoadingDraft }] = useDiscardDraftMutation();
  const { data: form } = useGetFormQuery(formId);
  const { data: draft } = useGetFormDraftQuery(formId);
  const { dirty } = useSelector(getForm);
  const toast = useToast();
  const isLoading = isLoadingUpdate || isLoadingPublish || isLoadingDraft;

  const handlePublish = async () => {
    try {
      await updateForm();
      await publishForm(formId);
      toast({
        title: 'Form published',
        status: 'success',
        variant: 'left-accent',
        isClosable: true,
        position: 'top',
        duration: 1000,
      });
    } catch (error) {
      toast({
        title: 'Error publishing form',
        description: 'Please try again later.',
        status: 'warning',
        variant: 'left-accent',
        isClosable: true,
        position: 'top',
        duration: 10000,
      });
    }
  };
  const handleDiscardDraft = () => {
    discardDraft(formId);
  };
  return (
    <EditorSidebar
      isLoading={isLoading}
      handleDiscardDraft={handleDiscardDraft}
      handlePublish={handlePublish}
      newChanges={dirty || form?.updated !== draft?.updated}
    />
  );
};

export default FormEditorSidebar;
